import { useMemo } from 'react';

import { getTestListingLockInfo } from './testListingLock';
import useTestListingLockState from './useTestListingLockState';

const useCardsWithListingLock = (goalUid, cards = []) => {
  const lockState = useTestListingLockState(goalUid);

  return useMemo(
    () =>
      cards.map((card) => {
        const lockInfo = getTestListingLockInfo({
          subscriptionFlags: {
            isIconic: card.isIconic,
            isSpecial: card.isSpecial
          },
          isSellable: card.isSellable,
          variant: card.variant,
          ...lockState
        });

        return {
          ...card,
          showLock: lockInfo.showLock,
          lockType: lockInfo.lockType,
          isLockedPlus: lockInfo.isLockedPlus,
          unlockedBySellableStore: lockInfo.unlockedBySellableStore
        };
      }),
    [cards, lockState]
  );
};

export default useCardsWithListingLock;
